import { render } from "./SubjetctDateils.vue?vue&type=template&id=109c823f"
import script from "./SubjetctDateils.vue?vue&type=script&lang=js"
export * from "./SubjetctDateils.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__